module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAM1BMVEUAMF4wVnwSPmlJa4wFNGEgSnLo7PD////z9fexv83M1d/6+/w8YITc4+lde5mUqLt+lq36fmJwAAAAe0lEQVQ4y+3SSQ6AIAwF0CJDmfX+pxWKJroAutXwt32h0AKw8udsXrCcTmgjzyHabe5McUHyHKNzc/O3iJF7tBG2ONNxMjj1crrnEC8ZRw5cKTZJLunu/W9Zj8Y0mvNOkpwf74Mkzh3AwXQAmZyaOlWlU6w/mJlu5Xs5AQInBDskRQnIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/NCAcmi_checkBox.png
// module id = 6AqT
// module chunks = 0